/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionType } from './QuestionType';
import {
    QuestionTypeFromJSON,
    QuestionTypeFromJSONTyped,
    QuestionTypeToJSON,
    QuestionTypeToJSONTyped,
} from './QuestionType';

/**
 * 
 * @export
 * @interface QuestionDTO
 */
export interface QuestionDTO {
    [key: string]: any | any;
    /**
     * 
     * @type {number}
     * @memberof QuestionDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof QuestionDTO
     */
    title?: string | null;
    /**
     * 
     * @type {QuestionType}
     * @memberof QuestionDTO
     */
    questionType?: QuestionType;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionDTO
     */
    options?: Array<string> | null;
}



/**
 * Check if a given object implements the QuestionDTO interface.
 */
export function instanceOfQuestionDTO(value: object): value is QuestionDTO {
    return true;
}

export function QuestionDTOFromJSON(json: any): QuestionDTO {
    return QuestionDTOFromJSONTyped(json, false);
}

export function QuestionDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionDTO {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'questionType': json['questionType'] == null ? undefined : QuestionTypeFromJSON(json['questionType']),
        'options': json['options'] == null ? undefined : json['options'],
    };
}

export function QuestionDTOToJSON(json: any): QuestionDTO {
    return QuestionDTOToJSONTyped(json, false);
}

export function QuestionDTOToJSONTyped(value?: QuestionDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'id': value['id'],
        'title': value['title'],
        'questionType': QuestionTypeToJSON(value['questionType']),
        'options': value['options'],
    };
}

